import React, { useState, useEffect } from 'react';

const ThemeToggle = () => {
  const [isDarkSide, setIsDarkSide] = useState(true);

  useEffect(() => {
    // Check for saved theme preference or default to dark side
    const savedTheme = localStorage.getItem('forcesight-theme');
    const prefersDark = savedTheme ? savedTheme === 'dark' : true;
    setIsDarkSide(prefersDark);
    updateTheme(prefersDark);
  }, []);

  const updateTheme = (isDark) => {
    const root = document.documentElement;
    
    if (isDark) {
      // Dark Side theme (original)
      root.classList.remove('light-side');
      root.classList.add('dark-side');
    } else {
      // Light Side theme (new glassy theme)
      root.classList.remove('dark-side');
      root.classList.add('light-side');
    }
  };

  const toggleTheme = () => {
    const newTheme = !isDarkSide;
    setIsDarkSide(newTheme);
    updateTheme(newTheme);
    localStorage.setItem('forcesight-theme', newTheme ? 'dark' : 'light');
  };

  return (
    <button 
      className="theme-toggle"
      onClick={toggleTheme}
      title={isDarkSide ? "Switch to light theme" : "Switch to dark theme"}
      aria-label="Toggle theme"
    >
      <div className="toggle-track">
        <div className={`toggle-thumb ${isDarkSide ? 'dark' : 'light'}`}>
          {isDarkSide ? '🌙' : '☀️'}
        </div>
        <span className="toggle-label dark-label">Dark</span>
        <span className="toggle-label light-label">Light</span>
      </div>
    </button>
  );
};

export default ThemeToggle;